import customAxios from "../../../API/customAxios";

export async function postEditEmployeeAllowance(showId, values) {
    values = {
        "id": values.id,
        "annual_allowances": values.annual_allowances,
        "sick_allowances": values.sick_allowances
    }
    return await customAxios.post(`/edit_employee_allowance/` + showId, values);
}

export async function postEditEmployeeApprover(firstApproverId, secondApproverId, showId) {
    return customAxios.post(`/edit_employee_approver/` + showId, {
        firstApproverId: firstApproverId,
        secondApproverId: secondApproverId,
    });
}